import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10",
  fill: "none",
  viewBox: "0 0 14 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12.133 1.15 5.075 8.21 1.866 5"
    }, null, -1)
  ])]);
}
const CheckedIcon = { render };
export {
  CheckedIcon as default,
  render
};
//# sourceMappingURL=checked.svg.js.map
